// extracted by mini-css-extract-plugin
module.exports =  {"styledErrorMessageRoot":"ErrorMessageWrapper-module__styledErrorMessageRoot--VZV2M","showBorder":"ErrorMessageWrapper-module__showBorder--I70Ug"};